/** Tab activo en Admin > Contrapartes (sin query string en la URL). */
export const ADMIN_CLIENT_TAB_STORAGE_KEY = 'admin.client.activeTab';

/** Tab a restaurar al volver desde detalle (no aplica en F5). */
export const ADMIN_CLIENT_TAB_RESTORE_KEY = 'admin.client.restoreTab';

export function persistAdminClientTab(tabId: string): void {
	try {
		sessionStorage.setItem(ADMIN_CLIENT_TAB_STORAGE_KEY, tabId);
	} catch {
		/* ignore quota / private mode */
	}
}

export function readAdminClientTab(): string | null {
	try {
		return sessionStorage.getItem(ADMIN_CLIENT_TAB_STORAGE_KEY);
	} catch {
		return null;
	}
}

/** Marca el tab al abrir detalle; se consume una vez al volver al listado. */
export function setRestoreAdminClientTab(tabId: string): void {
	try {
		sessionStorage.setItem(ADMIN_CLIENT_TAB_RESTORE_KEY, tabId);
		persistAdminClientTab(tabId);
	} catch {
		/* ignore */
	}
}

export function consumeRestoreAdminClientTab(): string | null {
	try {
		const tab = sessionStorage.getItem(ADMIN_CLIENT_TAB_RESTORE_KEY);
		if (tab) {
			sessionStorage.removeItem(ADMIN_CLIENT_TAB_RESTORE_KEY);
		}
		return tab;
	} catch {
		return null;
	}
}
